import { css } from 'styled-components';
export const BryntumGanttGlobalStyles = css`
  .b-theme-classic-light {
    .b-tooltip-content {
      background-color: var(--gray-100);
      color: var(--white-100);
    }

    .b-widget .b-anchor svg path {
      fill: var(--gray-100);
    }
  }
`;
